import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from 'app/auth/auth.service';
import { DATOS_API } from 'app/auth/auth.datos';

@Injectable({
  providedIn: 'root'
})
export class PreguntasService {

  idEmpresa: string;
  idUsuario: string;
  idInstituto: string;

  constructor(
    private http:HttpClient,
    private authService:AuthService
  ) {
    this.obtienInfo();
  }

  obtienInfo()
  {
    this.idUsuario = this.authService.getIdUsuario();
    this.idInstituto = this.authService.getInstituto();
    let infoUsu: any = this.authService.getInfoUsuario();
    // console.log(infoUsu);
    this.idEmpresa = infoUsu.empresaId;
  }

  getProdCertAct(){
    this.obtienInfo();
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.productos + this.idEmpresa);
  }
  getStatusProd(datos: any){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getStatusPart + this.idEmpresa, datos);
  }
  guardaStatusProd(datos: any){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaStatus + this.idEmpresa, datos);
  }
  DesbloquearPasoPorSeccion(datos){
    this.obtienInfo();
    console.log("datos colab::",datos);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaStatus + this.idEmpresa, datos);
  }
  getIdiomasProd(fecha: any){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getIdiomasGuardados + this.idEmpresa, fecha);
  }

  getCatIdiomasSurvey(){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.seccionesCatMaster.catalogos.idiomas);
  }
  getCatRespuestasReactivos(){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.seccionesCatMaster.catalogos.respuestasReactivos);
  }
  getCatDatosForAll(){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.seccionesCatMaster.catalogos.datosForAll + localStorage.getItem('instituto_id'));
  }
  getCatDemograficos(){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.seccionesCatMaster.catalogos.demograficos);
  }
  getCatalogo(instituto:string, tipoSeccion:string){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.seccionesCatMaster.getCatalogo + instituto + '/' + tipoSeccion);
  }
  getPreguntaCatMaster(idPregunta:number){
    return this.http.get<any>(DATOS_API.url + DATOS_API.endpoints.seccionesCatMaster.getPreguntaCatMaster + idPregunta);
  }
  setPreguntaCatMaster(datosPregunta:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.seccionesCatMaster.setPreguntaCatMaster, datosPregunta);
  }
  savePreguntaCatMaster(datosPregunta:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.seccionesCatMaster.savePreguntaCatMaster, datosPregunta);
  }
  buscaPreguntaCatMaster(textoPregunta:any, opcion:number, datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.seccionesCatMaster.buscaPreguntaCatMaster + textoPregunta + "/" + opcion, datos);
  }
  actualizaIdiomasCuestionario(surveyProductId:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.seccionesCatMaster.actualizaIdiomasCuestionario + surveyProductId, {});
  }
  getSeccionesCuestionario(surveyProductId:any){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.seccionesCatMaster.getSeccionesCuestionario + surveyProductId);
  }
  setSeccionesCuestionario(surveyProductId:any, secciones:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.seccionesCatMaster.setSeccionesCuestionario + surveyProductId, secciones);
  }
  saveCambiosTemplate(surveyProductId:any, datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.seccionesCatMaster.saveCambiosTemplate + surveyProductId, datos);
  }

  getInfoPeguntasIdUniquean(idUnique:any){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.seccionesCatMaster.getPreguntaCatMaster + idUnique);
  }
  generaAudioPregunta(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.tts, datos);
  }
  generaLinkMp3(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.linkMp3, datos);
  }
  saveQuestionAudio(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.saveQuestionAudio, datos);
  }
  getQuestionAudio(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getQuestionAudio, datos);
  }

}
